import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ContainerSepcificationService } from '../../../../shared/services/container-sepcification.service';

@Component({
    selector: 'app-container-specification',
    templateUrl: './container-specification.component.html',
    styleUrls: ['./container-specification.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContainerSpecificationComponent implements OnInit {

  constructor(private containerSepcificationService:ContainerSepcificationService) { }

  containerSpecificationList:any = [];
  SelectContainerSpecification:any;
  bMeasurementSystemList:any = [
    {name:'English',id:1},
    {name:'Metric',id:2},
  ]
  SelecteBMeasurementSystem:any = "1";
  containerSpecDetails:any = [];
  containerSpeceImage:any = "";
  containerSpecDetailsE:any= [];
  containerSpecDetailsI:any= [];
  isLoader:boolean = false;
  ngOnInit(): void {
    this.containerSepcificationService.getContainerSpecificationList().subscribe((res)=>{
      this.containerSpecificationList = res;
     // console.log(res)
    })
  }

  onSelected(){
   // console.log(this.SelecteBMeasurementSystem);
  
    if(this.SelectContainerSpecification){
      this.isLoader = true;
      this.containerSpecDetails = [];
      this.containerSpeceImage = "";
      let ob = {
        bMeasurementSystem:this.SelecteBMeasurementSystem,
        cContainerName:this.SelectContainerSpecification
      }
      this.containerSepcificationService.getSpecificationDetails(ob).subscribe((res)=>{
          this.containerSpecDetails.push(res[1]);
          this.containerSpeceImage = res[0].split('.')[0];
          this.isLoader = false;
      },(error)=>{
        this.isLoader = false;
      })
    }
     
  }

  onShowResultSelecte(){
    this.containerSpecDetails = [];
    this.containerSpeceImage = "";
    this.isLoader = true;
    let ob = {
      bMeasurementSystem:this.SelecteBMeasurementSystem,
      cContainerName:this.SelectContainerSpecification
    }
    this.containerSepcificationService.getSpecificationDetails(ob).subscribe((res)=>{
      this.containerSpecDetails.push(res[1]);
      this.containerSpeceImage = res[0].split('.')[0];
      this.isLoader = false;
    },(error)=>{
      this.isLoader = false;
    })
  }

  getValue(e:any){
    return parseFloat(e).toFixed(2);
  }

  noDecimal(e:any){
    return parseFloat(e).toFixed(0);
  }

}
